import Vue from 'vue'
import Router from 'vue-router'
import userBar from '../components/userCenter/userBar'
import mainBar from '../components/main/mainbar'

Vue.use(Router)
const constantRoutes = [
  {
    path: '/login',
    component: (resolve) => require(['@/components/login/login.vue'], resolve),
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/error/404'], resolve),
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/error/401'], resolve),
  },
  {
    path: '/index',
    component: (resolve) => require(['@/views/index'], resolve),
  },
  {
    path: '',
    component: (resolve) => require(['@/views/index'], resolve),
  },
  //用户中心路由
  {
    component: userBar,
    hidden: true,
    path: '',
    children: [
      {
        path: '/userInfoCenter',
        component: (resolve) => require(['@/views/userInfo/index.vue'], resolve)
      },
      {
        path: '/userAddress',
        component: (resolve) => require(['@/views/address/index.vue'], resolve)
      },
      {
        path: '/seeHistory',
        component: (resolve) => require(['@/views/history/index.vue'], resolve)
      },
      {
        path: '/follow',
        component: (resolve) => require(['@/views/follow/index.vue'], resolve)
      },
      {
        path: '/userGroup',
        component: (resolve) => require(['@/views/userGroup/index.vue'], resolve)
      },
      {
        path: '/changePassword',
        component: (resolve) => require(['@/views/changePassword/index.vue'], resolve)
      },
      {
        path: '/userInfoPayment',
        component: (resolve) => require(['@/views/userInfoPayment/index.vue'], resolve)
      }
    ]
  }, {
    path: '/register',
    component: (resolve) => require(['@/views/register/index'], resolve),
  },
  //智能补货
  {
    path: '/shopRestock',
    component: (resolve) => require(['@/views/shopRestock/index'], resolve),
  },
  //购物车
  {
    path: '/shopCar',
    component: (resolve) => require(['@/views/shopCar/index'], resolve),
  }
  //限时秒杀
  , {
    path: '/secKill',
    component: (resolve) => require(['@/views/secKill/index'], resolve),
  },
  //积分商城
  {
    path: '/scoreStore',
    component: (resolve) => require(['@/views/scoreStore/index'], resolve),
  },
  //团购商城
  {
    path: '/groupStore',
    component: (resolve) => require(['@/views/groupGoods/index'], resolve),
  },
  {
    path: '/shopCheck',
    component: (resolve) => require(['@/views/shopCheck/index.vue'], resolve)
  },
  {
    path: '/shopPurchase',
    component: (resolve) => require(['@/views/shopPurchase/index.vue'], resolve)
  },
  {
    path: '/shopAllot',
    component: (resolve) => require(['@/views/shopAllot/index.vue'], resolve)
  },
  {
    path: '/shopGoodsStock',
    component: (resolve) => require(['@/views/shopGoodsStock/index.vue'], resolve)
  },
  {
    path: '/shopReturn',
    component: (resolve) => require(['@/views/shopReturn/index.vue'], resolve)
  },
  {
    path: '/userCenterOrder',
    component: (resolve) => require(['@/views/order/index.vue'], resolve)
  },
  //主订单详情
  {
    path: '/mainOrderDetail',
    component: (resolve) => require(['@/views/mainOrderDetail/index'], resolve),
  },
  //订单详情
  {
    path: '/orderDetail',
    component: (resolve) => require(['@/views/orderDetail/index'], resolve),
  },
  //订单详情-收货单
  {
    path: '/receivingOrderDetail',
    component: (resolve) => require(['@/views/order/receivingOrder/detail'], resolve),
  },
  //订单详情-退货单
  {
    path: '/salesReturnOrderDetail',
    component: (resolve) => require(['@/views/order/salesReturnOrder/detail'], resolve),
  },
  //订单详情-退货单
  {
    path: '/orderDetailFee',
    component: (resolve) => require(['@/views/order/feeOrder/detail'], resolve),
  },
  //订单支付成功
  {
    path: '/paySuccess',
    component: (resolve) => require(['@/views/paySuccess/index'], resolve),
  },
  //预测订单详情
  {
    path: '/restockOrderDetail',
    component: (resolve) => require(['@/views/order/restockOrder/detail'], resolve),
  },
  //物料下单确认页面
  {
    name: 'purchaseInfo',
    path: '/purchaseInfo',
    component: (resolve) => require(['@/views/purchaseInfo/index'], resolve),
  },
  //订单支付页面
  {
    name: 'payConfirm',
    path: '/payConfirm',
    component: (resolve) => require(['@/views/payConfirm/index'], resolve),
  }
  ,
  //订单支付页面--费用单
  {
    name: 'payConfirmFee',
    path: '/payConfirmFee',
    component: (resolve) => require(['@/views/payConfirmFee/index'], resolve),
  }
  ,
  //通知
  {
    path: '/notice',
    component: (resolve) => require(['@/views/notice/index'], resolve),
  },
  {
    component: mainBar,
    hidden: true,
    path: '',
    children: [
      //物料详情
      {
        name: 'goodsDetail',
        path: '/goodsDetail',
        component: (resolve) => require(['@/views/goodsDetail/index'], resolve)
      },
      //物料列表
      {
        name: 'goodsList',
        path: '/goodsList',
        component: (resolve) => require(['@/views/goodsList/index'], resolve),

      },
    ]
  }

]

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js